// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__xnhHm","form":"styles_form__2y4X6"};